import { RequestPollResponse } from '../RateMaster/TypesInRateMaster/RequestPollResponse';
import BulkRequestData from './TypesInBulkRequest/BulkRequestData';

enum REQUEST_STATUS {
  SUCCESS = 'SUCCESS',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  EMPTY_FILE = 'EMPTY_FILE',
  INVALID_FILE = 'INVALID_FILE',
}

const statusOptions = [
  { key: REQUEST_STATUS.SUCCESS, label: 'Success' },
  { key: REQUEST_STATUS.PARTIAL_SUCCESS, label: 'Partial Success' },
  { key: REQUEST_STATUS.FAILED, label: 'Failed' },
  { key: REQUEST_STATUS.IN_PROGRESS, label: 'In Progress' },
  { key: REQUEST_STATUS.PENDING, label: 'Pending' },
  { key: REQUEST_STATUS.INVALID_FILE, label: 'Invalid File' },
];

const requestTypeOptions = [
  { key: 'Rate Master Add', label: 'Rate Master Add' },
  { key: 'Rate Master Update', label: 'Rate Master Update' },
];

const sortByOptions = [
  ['created_at', 'Created At'],
  ['updated_at', 'Updated At'],
];

const requestStatus = {
  PROCESSED: {
    icon: 'check-circle',
    status: 'Overwritten',
    iconColor: '#52C419',
  },
  SUCCESS: {
    icon: 'check-circle',
    status: 'Success',
    iconColor: '#52C419',
  },
  PARTIAL_SUCCESS: {
    icon: 'exclamation-circle',
    status: 'Partial Success',
    iconColor: '#FAAD14',
  },
  FAILED: {
    icon: 'close-circle',
    status: 'Failed',
    iconColor: '#F4222D',
  },
  EMPTY_FILE: {
    icon: 'close-circle',
    status: 'Empty File',
    iconColor: '#F4222D',
  },
  INVALID_FILE: {
    icon: 'close-circle',
    status: 'Invalid File',
    iconColor: '#F4222D',
  },
};

const downloadOptions = [
  { key: 'UPLOADED_DATA', label: 'Uploaded Data' },
  { key: 'SUCCESSFUL', label: 'Successful' },
  { key: 'ERRORS', label: 'Failed' },
  { key: 'PENDING', label: 'Pending' },
  { key: 'OTHER', label: 'Overwritten'}
];

const isDownloadOptionDisabled = (status: string, optionKey: string, record: BulkRequestData) => {
  const keyMap = {
    UPLOADED_DATA: status === REQUEST_STATUS.EMPTY_FILE || status === REQUEST_STATUS.INVALID_FILE,
    SUCCESSFUL: status === REQUEST_STATUS.FAILED || status === REQUEST_STATUS.PENDING ||
      status === REQUEST_STATUS.EMPTY_FILE || status === REQUEST_STATUS.INVALID_FILE,
    ERRORS: status === REQUEST_STATUS.SUCCESS || status === REQUEST_STATUS.PENDING ||
      status === REQUEST_STATUS.EMPTY_FILE || status === REQUEST_STATUS.INVALID_FILE,
    PENDING: status !== REQUEST_STATUS.PENDING,
    OTHER: record?.otherRows && record?.otherRows > 0 ? false : true,
  };
  return keyMap[optionKey];
};

const getUploadProgress = (request: Omit<RequestPollResponse, 'id' | 'fileName' | 'status'>)
  : { [key: string]: number } => {
  const totalRows = request.totalRows || 0;
  const successRows = request.successRows || 0;
  const errors = request.errors || 0;
  const otherRows = request.otherRows || 0;
  const percent = totalRows
    ? Math.floor(((successRows + errors + otherRows) / totalRows) * 100)
    : 0;
  const successPercentage = (successRows / totalRows) * 100 || 0;
  const errorPercentage = (errors / totalRows) * 100 || 0;
  return { percent, successPercentage, errorPercentage, totalRows,  successRows, errors, otherRows};
};

export {
  statusOptions,
  requestTypeOptions,
  sortByOptions,
  requestStatus,
  downloadOptions,
  getUploadProgress,
  REQUEST_STATUS,
  isDownloadOptionDisabled,
};
